/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import style from './AlertsContextMenu.module.css';
import {
  Menu,
  Item,
  // Separator,
  Submenu,
  theme,
  animation,
} from 'react-contexify';
import 'react-contexify/dist/ReactContexify.css';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';

export const AlertsContextMenu = ({ cols, rowHeight }) => {
  const { layoutStore } = useWebsocketStore();

  const addWatchlistModule = ({ props }) => {
    const pixelRatio = window.devicePixelRatio;
    const xPos = props.xPos / pixelRatio;
    const yPos = props.yPos / pixelRatio;
    const width = window.innerWidth;
    const x = Math.floor(xPos / (width / cols));
    const y = Math.floor((yPos - 70 / devicePixelRatio) / rowHeight);
    layoutStore.addModuleToCurrentLayout(
      'alerts',
      'alertWatchlist',
      x,
      y,
      4,
      3,
      { groupNumber: 0 }
    );
  };

  const addAlertWatchlistManagerModule = ({ props }) => {
    const pixelRatio = window.devicePixelRatio;
    const xPos = props.xPos / pixelRatio;
    const yPos = props.yPos / pixelRatio;
    const width = window.innerWidth;
    const x = Math.floor(xPos / (width / cols));
    const y = Math.floor((yPos - 70 / devicePixelRatio) / rowHeight);
    layoutStore.addModuleToCurrentLayout(
      'alerts',
      'watchlistManager',
      x,
      y,
      2,
      3,
      { groupNumber: 0 }
    );
  };

  const addAlertModule = ({ props }) => {
    const pixelRatio = window.devicePixelRatio;
    const xPos = props.xPos / pixelRatio;
    const yPos = props.yPos / pixelRatio;
    const width = window.innerWidth;
    const x = Math.floor(xPos / (width / cols));
    const y = Math.floor((yPos - 70 / devicePixelRatio) / rowHeight);
    layoutStore.addModuleToCurrentLayout('alerts', 'addAlert', x, y, 3, 4, {
      groupNumber: 0,
    });
  };
  const addChartModule = ({ props }) => {
    const pixelRatio = window.devicePixelRatio;
    const xPos = props.xPos / pixelRatio;
    const yPos = props.yPos / pixelRatio;
    const width = window.innerWidth;
    const x = Math.floor(xPos / (width / cols));
    const y = Math.floor((yPos - 70 / devicePixelRatio) / rowHeight);
    layoutStore.addModuleToCurrentLayout('alerts', 'chart', x, y, 2, 3, {
      groupNumber: 0,
    });
  };

  const addNotificationsModule = ({ props }) => {
    const pixelRatio = window.devicePixelRatio;
    const xPos = props.xPos / pixelRatio;
    const yPos = props.yPos / pixelRatio;
    const width = window.innerWidth;
    const x = Math.floor(xPos / (width / cols));
    const y = Math.floor((yPos - 70 / devicePixelRatio) / rowHeight);
    layoutStore.addModuleToCurrentLayout(
      'alerts',
      'notifications',
      x,
      y,
      4,
      3,
      {
        groupNumber: 0,
      }
    );
  };

  return (
    <Menu
      id="alertsContextMenu"
      theme={theme.dark}
      animation={animation.flip}
      className={style.menu}
    >
      <Submenu label="Add">
        <Item onClick={addWatchlistModule}>Alerts</Item>
        <Item onClick={addAlertModule}>Add Alert</Item>
        <Item onClick={addAlertWatchlistManagerModule}>Watchlist Manager</Item>
        <Item onClick={addChartModule}>Chart</Item>
        <Item onClick={addNotificationsModule}>Notifications</Item>
      </Submenu>
    </Menu>
  );
};

AlertsContextMenu.propTypes = {
  cols: PropTypes.number,
  rowHeight: PropTypes.number,
};
